"use client";
import { Box, Modal, Text } from "@quintoandar-tokko/jopijs";
import styles from "./styles.module.scss";
import ImageNext from "../shared/ImageNext";
import box from "@/public/box.svg";
import tokko from "@/public/tokko.svg";
import translations from "./ErrorComponent.trans.json";
import Trans from "@/components/shared/Trans";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setTheme, THEMES } from "@/store/slices/ThemeSlice";

export default function ErrorComponent() {
  const [isClient, setIsClient] = useState(false);
  const dispatch = useDispatch();

  const handleAction = () => {
    window.location.replace("https://www.tokkobroker.com");
  };

  // Error routes never receive a payload with from_univen, so the theme would
  // stay unresolved. This screen is Tokko-branded, so resolve it to Tokko.
  useEffect(() => {
    setIsClient(true);
    dispatch(setTheme(THEMES.TOKKOBROKER));
  }, [dispatch]);

  if (!isClient) return null;

  return (
    <Modal
      modalBG
      blockScroll
      width="900px"
      closeModal={handleAction}
      className={styles.modal}
    >
      <Box className={styles.contentContainer}>
        <Modal.Header
          closeIcon={handleAction}
          text=""
          variant={["start", "l"]}
        />
        <Modal.Body height="100%">
          <Box className={styles.container}>
            <Box className={styles.leftContainer}>
              <Box className={styles.textCont}>
                <ImageNext alt="logo" src={tokko} unoptimized />

                <Text>Oops !!!</Text>

                <Text>{Trans(translations, "SorrySomethingWentWrong")}.</Text>

                <Box className={styles.btn} onClick={handleAction}>
                  {Trans(translations, "Close")}
                </Box>
              </Box>
            </Box>
            <Box className={styles.boxCont}>
              <ImageNext width="50%" alt="logo" src={box} unoptimized />
            </Box>
          </Box>
        </Modal.Body>
      </Box>
    </Modal>
  );
}
